import {styled} from '@mui/material/styles'
import {Grid} from '@mui/material'

export const StyledAlertGrid = styled(Grid)(() => ({
  marginLeft: 'auto'
}))

export const StyledDivContainer = styled('div')(() => ({
  marginLeft: 'auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}))
